import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { estimateAttributesObjectSize as e } from "../../core/byteSizeEstimations.js";
import "../../core/has.js";
import { isSome as t, isNone as s } from "../../core/maybe.js";
import { estimateSize as r } from "../../core/typedArrayUtil.js";
import { generateUID as n } from "../../core/uid.js";
import o from "../../geometry/SpatialReference.js";
import { create as a, empty as i, expandWithNestedArray as l, expandWithAABB as p } from "../../geometry/support/aaBoundingBox.js";
import { create as c, empty as u, expandWithNestedArray as h, expand as m } from "../../geometry/support/aaBoundingRect.js";
import { unquantizePolyline as y, unquantizePolygon as f, unquantizeMultipoint as g, unquantizePoint as d } from "../../geometry/support/quantizationUtils.js";
import { isFeatureGeometryType as b, featureGeometryTypeKebabDictionary as x } from "../../geometry/support/typeUtils.js";
import Z from "../support/Field.js";
export { equals } from "./dehydratedFeatureComparison.js";

var j = function j(e, t, s) {
  _classCallCheck(this, j);

  this.uid = e, this.geometry = t, this.attributes = s, this.visible = !0, this.objectId = null, this.centroid = null;
};

function M(e) {
  return t(e.geometry);
}

function k(e) {
  return b(e.type);
}

var N = function N() {
  _classCallCheck(this, N);

  this.exceededTransferLimit = !1, this.features = [], this.fields = [], this.hasM = !1, this.hasZ = !1, this.geometryType = null, this.objectIdFieldName = null, this.globalIdFieldName = null, this.geometryProperties = null, this.geohashFieldName = null, this.spatialReference = null, this.transform = null;
};

function z(e) {
  var s = x.fromJSON(e.geometryType),
      r = o.fromJSON(e.spatialReference),
      n = e.transform,
      a = e.features.map(function (o) {
    var a = F(o, s, r, e.objectIdFieldName),
        i = a.geometry;
    if (t(i) && n) switch (i.type) {
      case "point":
        a.geometry = d(n, i, i, i.hasZ, i.hasM);
        break;

      case "multipoint":
        a.geometry = g(n, i, i, i.hasZ, i.hasM);
        break;

      case "polygon":
        a.geometry = f(n, i, i, i.hasZ, i.hasM);
        break;

      case "polyline":
        a.geometry = y(n, i, i, i.hasZ, i.hasM);
        break;

      case "extent":
      case "mesh":
        a.geometry = i;
    }
    return a;
  });
  return {
    geometryType: s,
    features: a,
    spatialReference: r,
    fields: e.fields ? e.fields.map(function (e) {
      return Z.fromJSON(e);
    }) : null,
    objectIdFieldName: e.objectIdFieldName,
    globalIdFieldName: e.globalIdFieldName,
    geohashFieldName: e.geohashFieldName,
    geometryProperties: e.geometryProperties,
    hasZ: e.hasZ,
    hasM: e.hasM,
    exceededTransferLimit: e.exceededTransferLimit,
    transform: null
  };
}

function F(e, t, s, r) {
  return {
    uid: n(),
    objectId: r && e.attributes ? e.attributes[r] : null,
    attributes: e.attributes,
    geometry: I(e.geometry, t, s),
    visible: !0
  };
}

function I(e, t, r) {
  if (s(e)) return null;

  switch (t) {
    case "point":
      {
        var _t = e;
        return {
          x: _t.x,
          y: _t.y,
          z: _t.z,
          m: _t.m,
          hasZ: null != _t.z,
          hasM: null != _t.m,
          type: "point",
          spatialReference: r
        };
      }

    case "polyline":
      {
        var _t2 = e;
        return {
          paths: _t2.paths,
          hasZ: !!_t2.hasZ,
          hasM: !!_t2.hasM,
          type: "polyline",
          spatialReference: r
        };
      }

    case "polygon":
      {
        var _t3 = e;
        return {
          rings: _t3.rings,
          hasZ: !!_t3.hasZ,
          hasM: !!_t3.hasM,
          type: "polygon",
          spatialReference: r
        };
      }

    case "multipoint":
      {
        var _t4 = e;
        return {
          points: _t4.points,
          hasZ: !!_t4.hasZ,
          hasM: !!_t4.hasM,
          type: "multipoint",
          spatialReference: r
        };
      }
  }
}

function v(e, t, s, r) {
  return {
    x: e,
    y: t,
    z: s,
    hasZ: null != s,
    hasM: !1,
    spatialReference: r,
    type: "point"
  };
}

function R(e) {
  if (s(e)) return 0;
  var t = 32;

  switch (e.type) {
    case "point":
      t += 42;
      break;

    case "polyline":
    case "polygon":
      {
        var _s = 0;

        var _r = 2 + (e.hasZ ? 1 : 0) + (e.hasM ? 1 : 0),
            _n = "polyline" === e.type ? e.paths : e.rings;

        var _iterator = _createForOfIteratorHelper(_n),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _e = _step.value;
            _s += _e.length;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        t += 8 * _s * _r + 64, t += 128 * _s, t += 34, t += 32 * (_n.length + 1);
        break;
      }

    case "multipoint":
      {
        var _s2 = 2 + (e.hasZ ? 1 : 0) + (e.hasM ? 1 : 0),
            _r2 = e.points.length;

        t += 8 * _r2 * _s2 + 64, t += 128 * _r2, t += 34, t += 32;
        break;
      }

    case "extent":
      t += 98, e.hasM && (t += 32), e.hasZ && (t += 32);
      break;

    case "mesh":
      t += r(e.vertexAttributes.position), t += r(e.vertexAttributes.normal), t += r(e.vertexAttributes.uv), t += r(e.vertexAttributes.tangent);
  }

  return t;
}

function A(t) {
  var s = 32;
  return s += e(t.attributes), s += 3, s += 8 + R(t.geometry), s;
}

function w(e) {
  if (s(e)) return 0;

  switch (e.type) {
    case "point":
      return 1;

    case "polyline":
      {
        var _t5 = 0;

        var _iterator2 = _createForOfIteratorHelper(e.paths),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _s3 = _step2.value;
            _t5 += _s3.length;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        return _t5;
      }

    case "polygon":
      {
        var _t6 = 0;

        var _iterator3 = _createForOfIteratorHelper(e.rings),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _s4 = _step3.value;
            _t6 += _s4.length;
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        return _t6;
      }

    case "multipoint":
      return e.points.length;

    case "extent":
      return 2;

    case "mesh":
      {
        var _t7 = e.vertexAttributes && e.vertexAttributes.position;

        return _t7 ? _t7.length / 3 : 0;
      }

    default:
      return;
  }
}

function S(e) {
  if (s(e)) return !1;

  switch (e.type) {
    case "extent":
    case "point":
      return !0;

    case "polyline":
      var _iterator4 = _createForOfIteratorHelper(e.paths),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _t8 = _step4.value;
          if (_t8.length > 0) return !0;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return !1;

    case "polygon":
      var _iterator5 = _createForOfIteratorHelper(e.rings),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _t9 = _step5.value;
          if (_t9.length > 0) return !0;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return !1;

    case "multipoint":
      return e.points.length > 0;

    case "mesh":
      return !e.loaded || e.vertexAttributes.position.length > 0;
  }
}

function T(e, t) {
  switch (i(t), "mesh" === e.type && (e = e.extent), e.type) {
    case "point":
      t[0] = t[3] = e.x, t[1] = t[4] = e.y, e.hasZ && (t[2] = t[5] = e.z);
      break;

    case "polyline":
      for (var _s5 = 0; _s5 < e.paths.length; _s5++) {
        l(t, e.paths[_s5], e.hasZ);
      }

      break;

    case "polygon":
      for (var _s6 = 0; _s6 < e.rings.length; _s6++) {
        l(t, e.rings[_s6], e.hasZ);
      }

      break;

    case "multipoint":
      l(t, e.points, e.hasZ);
      break;

    case "extent":
      t[0] = e.xmin, t[1] = e.ymin, t[3] = e.xmax, t[4] = e.ymax, null != e.zmin && (t[2] = e.zmin), null != e.zmax && (t[5] = e.zmax);
  }
}

function B(e, t) {
  T(e, P), p(t, P);
}

function J(e, t) {
  switch (u(t), "mesh" === e.type && (e = e.extent), e.type) {
    case "point":
      t[0] = t[2] = e.x, t[1] = t[3] = e.y;
      break;

    case "polyline":
      for (var _s7 = 0; _s7 < e.paths.length; _s7++) {
        h(t, e.paths[_s7]);
      }

      break;

    case "polygon":
      for (var _s8 = 0; _s8 < e.rings.length; _s8++) {
        h(t, e.rings[_s8]);
      }

      break;

    case "multipoint":
      h(t, e.points);
      break;

    case "extent":
      t[0] = e.xmin, t[1] = e.ymin, t[2] = e.xmax, t[3] = e.ymax;
  }
}

function L(e, s) {
  t(e) && (J(e, U), m(s, U, s));
}

function O(e, t) {
  return null != e.objectId ? e.objectId : e.attributes && t ? e.attributes[t] : null;
}

var P = a(),
    U = c();
export { j as DehydratedFeatureClass, N as DehydratedFeatureSetClass, T as computeAABB, J as computeAABR, R as estimateGeometryObjectSize, A as estimateSize, B as expandAABB, L as expandAABR, z as fromFeatureSetJSON, I as fromJSONGeometry, O as getObjectId, M as hasGeometry, S as hasVertices, k as isFeatureGeometry, v as makeDehydratedPoint, w as numVertices };